module.exports = __webpack_public_path__ + "img/logo-mini.60f319f3.png";